module.exports = __webpack_public_path__ + "static/media/4.e4ef7f1d.jpg";